import React from 'react'

export default function RefreshIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.76331 3.75735C4.8491 2.67157 6.3491 2 8.00592 2C10.2287 2 12.1693 3.20872 13.206 5.00474V3.33339C13.206 2.9652 13.5045 2.66673 13.8727 2.66673C14.2178 2.66673 14.5017 2.92906 14.5359 3.26523C14.5382 3.28764 14.5393 3.31038 14.5393 3.33339V6.66673C14.5393 6.84353 14.4691 7.01313 14.3441 7.13813C14.2191 7.26313 14.0494 7.3334 13.8727 7.3334H10.5393C10.1711 7.3334 9.87265 7.03493 9.87265 6.66673C9.87265 6.29853 10.1711 6.00005 10.5393 6.00005L12.2236 6.00006C11.4746 4.42339 9.86758 3.33333 8.00592 3.33333C6.71732 3.33333 5.55062 3.85567 4.70612 4.70016C4.28403 5.12225 3.94242 5.62482 3.70628 6.18288C3.58739 6.46387 3.32337 6.66665 3.01827 6.66665C2.57582 6.66665 2.2468 6.25399 2.40605 5.84119C2.71025 5.0526 3.17624 4.34443 3.76331 3.75735Z"
        fill="currentColor"
      />
      <path
        d="M12.2601 9.92105C12.0265 10.4377 11.7015 10.9041 11.3058 11.2998C10.4613 12.1443 9.29465 12.6667 8.00598 12.6667C6.14434 12.6667 4.53732 11.5766 3.78836 9.99992H5.47266C5.84085 9.99992 6.13932 9.70145 6.13932 9.33325C6.13932 8.96505 5.84085 8.66659 5.47266 8.66659H2.13932C1.96251 8.66659 1.79294 8.73679 1.66792 8.86185C1.54289 8.98685 1.47266 9.15645 1.47266 9.33325V12.6666C1.47266 13.0118 1.73499 13.2957 2.07116 13.3298C2.09357 13.3321 2.11631 13.3333 2.13932 13.3333C2.50751 13.3333 2.80599 13.0348 2.80599 12.6666V10.9954C3.84276 12.7913 5.78321 14 8.00598 14C9.66278 14 11.1628 13.3284 12.2486 12.2426C12.8357 11.6555 13.3017 10.9474 13.6059 10.1588C13.7651 9.74599 13.4361 9.33332 12.9937 9.33332C12.6885 9.33332 12.4245 9.53612 12.3057 9.81705C12.2909 9.85199 12.2757 9.88665 12.2601 9.92105Z"
        fill="currentColor"
      />
    </svg>
  )
}
